import { useEffect, useState } from "react";
import axios from "axios";
import { BACKEND_URL as BACKEND } from "./api";

// Fallback images used when the admin hasn't uploaded a custom one.
export const DEFAULT_IMAGES = {
  hero: "https://images.pexels.com/photos/4133107/pexels-photo-4133107.jpeg",
  car: "https://images.pexels.com/photos/13767773/pexels-photo-13767773.jpeg",
  lote: "https://images.unsplash.com/photo-1688991057964-75b1e35211ae",
};

export function resolveContent(data) {
  const next = { ...DEFAULT_IMAGES };
  if (data) {
    Object.keys(DEFAULT_IMAGES).forEach((k) => {
      if (data[k] && data[k].url) {
        next[k] = `${BACKEND}${data[k].url}?v=${encodeURIComponent(data[k].v || "")}`;
      }
    });
  }
  return next;
}

export function useSiteImages() {
  const [images, setImages] = useState(DEFAULT_IMAGES);
  useEffect(() => {
    let active = true;
    axios
      .get(`${BACKEND}/api/content`)
      .then(({ data }) => active && setImages(resolveContent(data)))
      .catch(() => {});
    return () => {
      active = false;
    };
  }, []);
  return images;
}

export const VIDEO_KEYS = ["video1", "video2"];

export function resolveVideos(data) {
  const out = { video1: null, video2: null };
  if (data) {
    VIDEO_KEYS.forEach((k) => {
      if (data[k] && data[k].url) out[k] = `${BACKEND}${data[k].url}?v=${encodeURIComponent(data[k].v || "")}`;
    });
  }
  return out;
}

export function useSiteVideos() {
  const [videos, setVideos] = useState({ video1: null, video2: null });
  useEffect(() => {
    let active = true;
    axios
      .get(`${BACKEND}/api/content`)
      .then(({ data }) => active && setVideos(resolveVideos(data)))
      .catch(() => {});
    return () => {
      active = false;
    };
  }, []);
  return videos;
}
